import { render, staticRenderFns } from "./PromptRecommendationsFetcher.vue?vue&type=template&id=fe88a156&scoped=true&"
import script from "./PromptRecommendationsFetcher.vue?vue&type=script&lang=js&"
export * from "./PromptRecommendationsFetcher.vue?vue&type=script&lang=js&"
import style0 from "./PromptRecommendationsFetcher.vue?vue&type=style&index=0&id=fe88a156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe88a156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
